var React = require('react');

function ArrowDown (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"id":"defs98","key":0}),React.createElement("path",{"d":"m 293.751,389.868 c -20.181,20.179 -53.165,19.913 -73.673,-0.595 v 0 C 199.57,368.765 199.305,335.78 219.484,315.601 l 189.999,-190 c 20.178,-20.178 53.164,-19.913 73.672,0.595 v 0 c 20.508,20.509 20.772,53.492 0.595,73.671 z","id":"path91","key":1}),React.createElement("path",{"d":"m 220.249,389.868 c 20.18,20.179 53.164,19.913 73.672,-0.595 v 0 c 20.509,-20.508 20.774,-53.493 0.596,-73.672 l -190,-190 C 84.339,105.423 51.353,105.688 30.846,126.196 v 0 c -20.508,20.509 -20.772,53.492 -0.595,73.671 z","id":"path93","key":2})]);
}

ArrowDown.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"512px","height":"512px","viewBox":"0 0 512 512","enableBackground":"new 0 0 512 512"};

module.exports = ArrowDown;

ArrowDown.default = ArrowDown;
